export default __webpack_public_path__ + "static/media/blue_doc.e9f51bd5.svg";